import { ReactElement } from 'react'

import { useReactiveVar } from '@apollo/client'
import classNames from 'classnames'

import { QAModeVar } from '@web/hooks/useGlobalQAMode'
import { MissionRewardPopupType } from '@web/pages/mission/components/MissionRewardPopup/MissionRewardPopup.enum'

import Description, { DescriptionProps } from './elements/Description'
import NextStepPreview, { NextStepPreviewProps } from './elements/NextStepPreview'
import Reward from './elements/Reward'
import Title from './elements/Title'
import { MissionCardProps } from './MissionCard'
import styles from './MissionCard.module.scss'
import QAMissionCard from './QAMissionCard'

export interface ProgressMissionCardProps {
  type?: string
  missionCard: MissionCardProps
  Guide?: ReactElement | string
  Content: ReactElement
  step?: number
  nClickArea?: DescriptionProps['nClickArea'] & NextStepPreviewProps['nClickArea']
}

const ProgressMissionCard = ({ type, missionCard, Guide, Content, step, nClickArea }: ProgressMissionCardProps) => {
  const { name, description, label, reward } = missionCard

  const QAMode = useReactiveVar(QAModeVar)

  let natureCategoryDesc = null
  // 여름 미션한정 임시로 하드코딩
  if (missionCard.name === MissionRewardPopupType.SUMMER_NATURE_REVIEW) {
    natureCategoryDesc = (
      <>
        집 근처 공원부터 해변, 숲 등<br />
        여름을 보낸 자연, 명소를 <strong>사진과 함께 소개해주세요!</strong>
      </>
    )
  }

  // 가을 명소 미션한정 임시로 하드코딩
  if (missionCard.name === MissionRewardPopupType.AUTUMN_NATURE_REVIEW) {
    natureCategoryDesc = (
      <>
        집 근처 공원부터 가을의 아름다움을 담은
        <br />
        자연, 명소를 <strong>사진과 함께 소개해주세요!</strong>
      </>
    )
  }

  // 겨울 명소 미션한정 임시로 하드코딩
  if (missionCard.name === MissionRewardPopupType.WINTER_NATURE_REVIEW) {
    natureCategoryDesc = (
      <>
        집 근처 공원부터 겨울의 아름다움을 담은
        <br />
        자연, 명소를 <strong>사진과 함께 소개해주세요!</strong>
      </>
    )
  }

  return (
    <div className={classNames(styles.mission_card, { [styles.type_profile_border]: type === 'profile_border' })}>
      {/* 미션 제목 */}
      <Title title={name} label={label} emojiUrl={missionCard.iconUrl} />
      {/* 미션 설명 */}
      {description && <Description text={natureCategoryDesc ?? description} guide={Guide} nClickArea={nClickArea} />}
      {/* 미션 내용 */}
      {QAMode ? <QAMissionCard missionCard={missionCard} /> : Content}
      {/* 미션 보상 */}
      <Reward step={step} {...reward} />
      {/* 다음 단계 미리 보기 */}
      {missionCard.nextStepPreview && <NextStepPreview missionCard={missionCard} nClickArea={nClickArea} />}
    </div>
  )
}

export default ProgressMissionCard
